export function MobileSVG() {
    return (
      <svg
        width="375"
        height="1139"
        viewBox="0 0 375 1139"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1905_1208)">
          <path
            d="M408.048 780.529C407.582 781.383 407.041 782.204 406.66 783.097C399.662 799.502 386.034 810.354 373.918 822.512C363.5 832.974 351.402 841.142 338.638 848.209C330.66 852.636 322.271 856.386 312.488 856.146C304.025 855.942 295.619 856.008 287.239 854.492C281.299 853.432 276.202 850.236 270.674 848.129C267.311 846.854 264.043 845.314 260.748 843.89C259.684 843.406 258.62 842.921 258.875 844.927C260.587 860.093 257.444 875.001 256.247 890.011C255.279 902.233 254.322 914.486 252.434 926.584C249.677 944.368 246.284 962.055 242.848 979.722C241.277 987.851 237.455 995.367 235.27 1003.27C232.819 1012.09 227.613 1019.4 223.199 1027.17C222.303 1028.74 220.777 1029.67 219.409 1030.75C213.03 1035.98 207.289 1042.07 199.458 1045.33C198.146 1045.94 196.702 1046.19 195.262 1046.08C190.133 1045.61 184.872 1045.68 179.892 1044.57C173.028 1043.17 166.566 1040.25 160.983 1036.02C149.032 1026.72 141.542 1013.83 133.766 1001.32C130.791 996.569 129.143 991.048 126.921 985.858C123.064 976.812 119.109 967.811 115.438 958.695C111.869 949.805 110.06 940.381 107.978 931.102C105.23 918.833 100.467 907.459 95.3228 896.077C91.0422 886.607 88.0958 876.548 84.6207 866.776C79.5706 852.348 74.5833 837.915 69.6584 823.475C62.4764 802.578 56.2992 781.393 49.5983 760.343C49.1132 758.765 48.3512 757.286 47.3482 755.975C42.4777 749.745 37.6121 743.505 32.9285 737.232C32.603 736.642 32.0816 736.185 31.4545 735.939C30.8275 735.693 30.1343 735.675 29.4947 735.886C26.5763 736.652 23.5031 736.461 20.7465 737.944C15.8182 740.584 15.2235 745.442 15.3454 749.998C16.1373 784.955 19.9627 819.775 26.7783 854.067C29.2531 866.289 31.7957 878.503 33.5833 890.823C34.6437 898.197 34.1111 905.797 34.6363 913.274C35.2876 922.223 36.8428 930.992 41.4869 938.931C49.9077 953.386 58.4021 967.848 66.0221 982.736C72.7479 995.891 78.2973 1009.66 80.8052 1024.4C80.8956 1024.97 80.8719 1025.56 80.7352 1026.13C80.5984 1026.7 80.3514 1027.23 80.0083 1027.7C76.3248 1033.53 73.0174 1039.63 67.8729 1044.41C67.2337 1045.14 66.4392 1045.72 65.5477 1046.1C59.3852 1048.18 53.1588 1049.36 46.6985 1047.66C46.3036 1047.62 45.9257 1047.48 45.6005 1047.25C42.0674 1043.73 37.4562 1041.21 35.1317 1036.81C28.7917 1024.78 20.8065 1013.86 12.889 1002.92C2.83517 989.036 -4.27327 973.533 -12.531 958.664C-22.1544 941.322 -26.144 922.187 -30.6175 903.128C-35.848 880.768 -35.9725 857.943 -37.6774 835.26C-38.9406 818.461 -39.9532 801.647 -40.9135 784.831C-42.1617 762.189 -39.8871 740.02 -32.1225 718.462C-28.5393 708.584 -22.593 699.733 -14.8032 692.682C-8.5481 687.061 -1.11729 682.909 6.94606 680.529C13.4365 678.549 19.9955 678.477 26.5787 678.493C30.3149 678.498 33.462 681.038 37.0327 681.97C48.2168 685.085 56.1073 693.23 65.0426 699.872C70.7135 704.062 73.9226 710.075 78.2232 715.299C90.0292 729.599 96.9569 746.626 105.126 762.959C106.463 765.664 107.626 768.469 109.138 771.074C115.775 782.479 117.809 795.387 121.295 807.813C130.913 842.032 138.756 876.652 147.125 911.216C149.321 920.495 153.668 929.315 157.043 938.347C158.264 941.616 159.965 944.82 160.74 948.169C163.148 958.985 170.921 965.753 178.477 972.743C179.787 973.957 180.337 973.397 181.071 972.125C187.662 960.524 193.159 948.334 197.49 935.714C202 922.74 206.156 909.669 209.883 896.467C211.942 889.126 211.717 881.412 213.114 873.975C216.256 857.292 212.821 840.776 211.886 824.242C211.5 817.728 210.765 811.248 210.311 804.742C210.282 803.927 210.084 803.127 209.727 802.394C209.371 801.66 208.866 801.01 208.243 800.483C198.81 791.918 189.472 783.255 180.054 774.684C176.121 771.105 174.224 766.217 171.597 761.832C165.35 751.384 159.246 740.86 153.283 730.259C147.96 720.737 144.107 710.497 139.626 700.563C130.461 680.241 121.564 659.81 112.316 639.527C108.85 631.906 107.359 623.758 105.137 615.803C102.915 607.849 101.153 599.731 98.7856 591.813C96.7608 584.977 96.9948 577.949 96.4778 570.99C95.332 555.709 99.0245 541.399 105.909 527.951C108.241 523.213 111.938 519.282 116.523 516.664C122.626 513.223 129.301 510.915 136.224 509.852C139.945 509.271 142.974 511.307 146.339 512.043C158.359 514.677 167.66 522.63 178.046 528.428C179.006 529.091 179.849 529.909 180.54 530.849C186.368 537.515 192.14 544.22 197.968 550.886C199.774 553.18 201.326 555.663 202.598 558.291C209.663 570.984 216.608 583.687 223.713 596.321C226.732 601.708 227.518 607.709 229.176 613.517C234.986 634.607 240.708 655.748 246.343 676.939C248.125 683.574 247.901 690.44 248.516 697.212C250.651 723.04 252.709 748.858 254.691 774.666C254.849 776.744 255.569 777.843 257.68 778.201C259.212 778.559 260.717 779.026 262.183 779.596C276.216 784.24 289.913 782.149 303.616 777.901C309.594 776.06 314.746 772.815 320.139 770.001C325.927 766.968 331.601 763.651 337.69 761.283C345.107 758.452 349.796 752.926 353.638 746.551C360.007 735.954 366.429 725.381 372.045 714.35C376.797 705.48 379.362 695.603 379.528 685.542C379.549 677.401 377.103 670.052 374.647 662.582C372.192 655.113 369.728 648 367.429 640.666C365.99 636.154 363.257 632.338 360.92 628.303C355.678 619.307 350.159 610.468 345.019 601.417C341.293 594.847 335.555 590.099 330.558 584.711C320.103 573.444 309.508 562.314 298.773 551.321C293.601 546.008 287.119 542.272 281.249 537.785C273.136 531.595 264.838 525.642 256.644 519.545C252.553 516.511 247.901 514.456 243.383 512.218C235.301 508.189 227.852 502.881 219.097 500.216C204.215 495.687 189.246 491.375 174.496 486.443C165.233 483.342 155.622 480.751 147.898 474.327C147.249 473.904 146.666 473.387 146.168 472.793C141.265 465.057 136.073 457.305 134.84 448.053C134.435 444.996 134.77 441.886 135.816 438.985C136.863 436.083 138.591 433.475 140.855 431.381C142.943 429.362 145.456 427.795 147.713 425.943C148.426 425.443 149.281 425.188 150.151 425.215C157.426 424.758 164.729 425.035 171.948 426.043C185.92 427.663 198.877 432.781 212.173 436.73C227.68 441.325 242.373 448.16 257.78 453.031C263.697 454.904 268.611 458.698 274 461.59C281.71 465.732 289.624 469.594 296.978 474.294C317.597 487.466 336.273 503.096 354.252 519.668C362.934 527.711 369.285 537.43 376.891 546.256C386.3 557.189 391.189 570.485 397.059 583.263C405.79 602.282 413.006 621.948 420.934 641.32C423 646.375 422.946 652.02 424.292 657.3C428.697 674.592 428.391 692.271 427.887 709.847C427.658 717.456 425.112 724.935 423.788 732.495C421.748 744.024 418.426 755.238 415.192 766.453C413.755 771.442 410.944 776.089 408.791 780.816L408.048 780.529ZM207.41 725.347L207.423 725.713C207.423 725.713 207.482 725.585 207.491 725.564C207.454 725.492 207.406 725.427 207.348 725.37C207.415 724.703 207.433 724.033 207.402 723.363C206.039 711.661 204.786 699.944 203.241 688.274C202.128 679.437 201.898 670.41 199.264 661.753C196.221 651.793 193.448 641.749 190.421 631.782C186.8 619.989 183.95 608.085 177.294 597.314C170.462 585.875 162.963 574.848 154.836 564.29C152.825 561.767 147.931 560.553 145.607 561.989C144.044 562.91 143.209 567.028 144.061 569.641C147.406 579.821 150.756 589.99 154.111 600.149C158.838 614.477 162.622 629.211 168.519 643.03C180.085 670.154 191.09 697.549 205.672 723.269C206.087 724.05 206.165 725.204 207.41 725.347V725.347Z"
            fill="#E1D5F9"
          />
          <path
            d="M326.633 501V519.609"
            stroke="#30A4FB"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M326.633 531.651V550.26"
            stroke="#30A4FB"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M351.265 525.63H332.656"
            stroke="#30A4FB"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M320.609 525.63H302"
            stroke="#30A4FB"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M337.472 536.469L330.891 529.888"
            stroke="#30A4FB"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M322.378 521.372L315.797 514.791"
            stroke="#30A4FB"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M337.472 514.791L330.891 521.372"
            stroke="#30A4FB"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M322.378 529.888L315.797 536.469"
            stroke="#30A4FB"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34 612C57.7482 612 77 592.748 77 569C77 545.252 57.7482 526 34 526C10.2517 526 -9 545.252 -9 569C-9 592.748 10.2517 612 34 612Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M305.398 1V15.4225"
            stroke="#FF3058"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M305.398 35.5737V49.9999"
            stroke="#FF3058"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M330.411 25.6001H315.984"
            stroke="#FF3058"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M295.426 25.6001H281"
            stroke="#FF3058"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M321.098 41.2991L316 36.1973"
            stroke="#FF3058"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M294.965 15.1702L289.867 10.0684"
            stroke="#FF3058"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M321.364 9.63428L316.266 14.7361"
            stroke="#FF3058"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M294.688 36.3159L289.586 41.4178"
            stroke="#FF3058"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1905_1208"
            x="-147.002"
            y="0.25"
            width="657.812"
            height="1146.37"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1905_1208"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1905_1208"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  }